import { createFileRoute } from '@tanstack/react-router';
import { OrderList } from '@/components/sales/order-list';

export const Route = createFileRoute('/sales/delivery-challans/')({ component: DeliveryChallans });

function DeliveryChallans() {
  return <OrderList kind="delivery_challan" />;
}
